import React, { useEffect, useState, useCallback, useRef } from 'react'
import { Button, TicketVistaCard } from '@app/components/index';

function TabsTicketCreate({
    filtro,
    items,
    setTkCreatedPage,
    hasMore,
    isLoading
}) {
    const [tickets, setTickets] = useState(items);
    const observerRef = useRef(null);

    const lastItemRef = useCallback((node) => {
        if (isLoading) return;
        if (observerRef.current) observerRef.current.disconnect();
        observerRef.current = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting && hasMore) {
                setTkCreatedPage((prev) => prev + 1);
            }
        });
        if (node) observerRef.current.observe(node);
    }, [isLoading, hasMore, setTkCreatedPage]);

    useEffect(() => {
        if(filtro==='TODOS'){
            setTickets(items);
        }else{
            setTickets(items?.filter(ticket => ticket.estado_tk === filtro));
        }
    }, [filtro,items])

    return (
        <div className="p-3 p-lg-5">
            {tickets?.length > 0 && (
                <div className="mb-3">
                    <span
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            backgroundColor: '#dc3545',
                            color: '#fff',
                            borderRadius: '20px',
                            padding: '4px 12px',
                            fontSize: '13px',
                            fontWeight: '600',
                        }}
                    >
                        <i className="fas fa-ticket-alt mr-1" />
                        {tickets.length}
                        {' ticket'}
                        {tickets.length !== 1 ? 's' : ''}
                    </span>
                </div>
            )}
            <div className="row">
                <div className="offset-lg-12 col-lg-12">
                    { tickets && tickets?.length > 0 ? (
                        <>
                            {tickets.map((ticket, index) => {
                                const isLast = index === tickets.length - 1;
                                return (
                                    <div
                                        ref={isLast ? lastItemRef : null}
                                        key={ticket.id_tk}
                                        className="mb-3"
                                    >
                                        <TicketVistaCard
                                            item={ticket}
                                            tratos={ticket.tratos}
                                            hideClickMap
                                        />
                                    </div>
                                )
                            })}
                            {(hasMore || isLoading) && (
                                <div className="text-center py-3">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="sr-only">
                                            Cargando...
                                        </span>
                                    </div>
                                </div>
                            )}
                        </>
                    ):(
                        <div className='alert alert-light mt-2 text-center'>
                            <i className="fas fa-inbox" style={{fontSize: 200, color: 'gray'}} />
                            <div style={{fontSize: 20, color: 'gray'}}>
                                Aún no creaste tickets
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}


export default TabsTicketCreate;